import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import { store } from './store/store'
import jwt from "jsonwebtoken"
import '@/assets/css/main.css';
import SMFTitleMixin from './Mixins/SMFTitleChange'
import DateFormatters from './Mixins/DateFormatter'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536
  }
})

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCircle, faCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

const defaultOptions = {
  //baseURL: "http://uk-labsrv:50195/Adept/api/",
  //Primary URL:
  //baseURL: "https://adeptapialt.geniusppt.com/Adept/api/",
  //Secondary URL:
  baseURL: "https://adeptapialt.geniusppt.com/Adept/Secondary/api/",
  headers: {
    'Content-Type': 'application/json',
  },
};

let instance = axios.create(defaultOptions);
instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token ? `Bearer ${token}` : '';
  }
  return config;
});

Vue.prototype.$http = instance

//Used to provide auth locking to page
router.beforeEach(async (to, from, next) => {
  //Checks if the route has the auth meta tag
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //Checks if the client has been provided a JWT auth
    if (localStorage.getItem('token') == null) {
      //Sends user back to login if the token is null
      next({
        path: '/',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {

      //Check to make sure the token is still valid
      const token = localStorage.getItem("token");
      var x = jwt.decode(token);
      //Checks the expiration of the token
      if ((new Date().getTime() / 1000) > x.exp) {
        localStorage.clear;
        next({ name: "Login" });
      } else {
        //All authenticated pages need the user object so we will get it here and insert it into the state object 
        //This means if the user refreshes a page the object will still persist
        instance.post(`Authenticate/ping?message=NavigateTo:${to.name}`)

        if (
          store.getters.user == null ||
          Object.keys(store.getters.user).length === 0
        ) {
          //Get all user info
          instance
            .post("Party/getParty?partyId=0", {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            })
            .then(
              async (res) => {
                //Stores the user object in the data store
                let initialData = res.data
                let caseId = 0;

                await instance.post("Party/getPartyRoles?partyId=" + initialData.id + "&getCases=true").then(res => { caseId = res.data[0].caseData.Id; })
                await instance.post("Party/getPartyAddress?partyAddressId=" + initialData.id).then(res => { initialData.address = res.data })
                await instance.post("Party/getPartyMethods?partyId=" + initialData.id).then(res => { initialData.contact = res.data })
                await instance.post("vehicle/getVehicle?caseId=" + caseId).then(res => { initialData.vehicleDetails = res.data }).catch(error => { console.log(error) })
                await instance.post("Vehicle/getVehicleFinanceDetail?caseId=" + caseId).then(res => { initialData.startDate = res.data.startDate; initialData.endDate = res.data.endDate }).catch(error => { console.log(error) })
                await instance.post("Case/getCaseSummary?caseId=" + caseId).then(res => {initialData.case = res.data })
                await instance.post("Case/getCase?caseId=" + caseId).then(res => { initialData.case.agreementNo = res.data.clientsReference })
                await instance.post("Ledger/getRealexPayHistory?caseID=" + caseId).then(res => {

                  var payments = res.data.map(function (x) {
                    let method = ""

                    if (x.agent === "SafePay" || x.agent === "AdeptPortal") {
                      method = x.agent
                    } else {
                      method = "Manual"
                    }
                    let dateObj = new Date(x.timestamp)
                    let date = dateObj.getDate() + "/" + (dateObj.getMonth() + 1) + "/" + dateObj.getFullYear()
                    return {
                      "date": date,
                      "amount": x.amount,
                      "method": method,
                      "description": "",
                      "type": x.eventType
                    }
                  })
                  initialData.realexPayments = payments;
                })
                await instance.post("Ledger/getCasePayments?caseId=" + caseId).then(res=>{
                  
                  var payments = res.data.map(function(x){
                    let dateObj = new Date(x.effectiveDate)
                    let date = dateObj.getDate() + "/" + (dateObj.getMonth() + 1) + "/" + dateObj.getFullYear()
                    
                    return {
                      "date": date,
                      "amount": x.amount,
                      "method": x.reference,
                      "type": x.type,
                      "description": x.description
                    }
                  })
                  initialData.panPayments = payments;
                })

                store.commit("change", initialData);
                next();
              },
              error => {
                //Checks token validity, 401 is an unauthorised request code
                if (error.message.includes("401")) {
                  localStorage.clear();
                  next({
                    path: '/',
                    params: { nextUrl: to.fullPath }
                  })
                }
              }
            );

          instance.post("Tenant/getContactInfo").then(res => {
            store.commit("changeContactInfo", res.data)
          })

        } else {
          next()
        }
      }
    }
  } else {
    //If the page doesnt require auth, this will serve the page as normal
    next();
  }
})

Vue.mixin(SMFTitleMixin)
Vue.mixin(DateFormatters)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
